import { createAppContext } from 'mini-app-context';

export const RsvpContextObject = createAppContext();
